/** Short positioning statement about the evening and who it connects. */
import { useLocalisation } from '@archipro-website/localisation';

import { ScrollReveal } from './components/ScrollReveal';
import { getHDEHomeownerDemonym } from './utils/hde-event-copy';

interface EventIntroProps {
    onRegister?: () => void;
    showRegisterButton?: boolean;
    isMobile?: boolean;
}

export const EventIntro = ({
    onRegister,
    showRegisterButton = true,
    isMobile = false,
}: EventIntroProps) => {
    const { country } = useLocalisation();
    const homeownerDemonym = getHDEHomeownerDemonym(country);

    if (isMobile) {
        return (
            <section
                data-testid="event-intro"
                className="relative w-full bg-white px-[1.5rem] py-[2.15rem]"
            >
                <ScrollReveal animation="fade-up" duration={500}>
                    <p className="font-ghost text-[1.62rem] uppercase leading-[1.79rem] tracking-[-0.015em] text-[#141414]">
                        {`A curated evening connecting ${homeownerDemonym} homeowners with the architects, designers, builders and brands shaping the way we live. Presented by ArchiPro.`}
                    </p>
                </ScrollReveal>
            </section>
        );
    }

    return (
        <section
            data-testid="event-intro"
            className="relative w-full bg-white px-[3.125rem] pb-[3.125rem] pt-[10rem]"
        >
            <ScrollReveal animation="fade-up" duration={700}>
                <p className="font-ghost text-[6rem] leading-[0.96] tracking-[-0.12rem] text-black">
                    <em className="font-normal italic">A curated evening</em>
                    {` connecting ${homeownerDemonym} homeowners with the architects, designers, builders and brands shaping the way we live. Presented by ArchiPro.`}
                </p>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" duration={400} delay={300}>
                <button
                    type="button"
                    onClick={onRegister}
                    className={`mt-[2.875rem] flex h-[3.125rem] items-center justify-center rounded-full border border-black bg-[#1e1e1e] px-[2.232rem] transition-colors hover:bg-gray-700 active:scale-[0.97] ${showRegisterButton ? '' : 'pointer-events-none invisible'}`}
                >
                    <span className="whitespace-nowrap text-[1.056rem] font-normal leading-[1.716rem] text-white">
                        Register Now – Free
                    </span>
                </button>
            </ScrollReveal>
        </section>
    );
};
